import { render, staticRenderFns } from "./PermissionsApplicationsView.vue?vue&type=template&id=88e7250a&"
import script from "./PermissionsApplicationsView.vue?vue&type=script&lang=js&"
export * from "./PermissionsApplicationsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports